import { Routes, Route } from "react-router-dom";
import ParticipationDetail from "./ParticipationDetail";

export default function ParticipationsRoutes() {
  return (
    <Routes>
      <Route path=":id" element={<ParticipationDetail />} />
    </Routes>
  );
}
